import { render, staticRenderFns } from "./JobPreviewViewPoints.vue?vue&type=template&id=70eb29e1&scoped=true"
import script from "./JobPreviewViewPoints.vue?vue&type=script&lang=js"
export * from "./JobPreviewViewPoints.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewViewPoints.vue?vue&type=style&index=0&id=70eb29e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb29e1",
  null
  
)

export default component.exports